/**
 * Keys used in DeviceObservation::refs.
 */
export enum DeviceObservationRefsKey {
  DEVICE_OBSERVATION_TYPE = 'DEVICE_OBSERVATION_TYPE',
  CORRELATION_ID = 'CORRELATION_ID',
}
